import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { profileRoutes } from '../../../utils/consts';
import './headerAuth.scss';

const HeaderAuth = ({ signOut = () => {}, fullName = '' }) => {
  const [isShow, setIsShow] = useState(false);
  const authRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (authRef.current && !authRef.current.contains(event.target)) {
      setIsShow(false);
    }
  };

  const AUTHENTICATION_LIST = [
    {
      id: 'dashboard',
      label: 'profile.mydashboard',
      onClick: () => navigate(profileRoutes.dashboard),
    },
    {
      id: 'signout',
      label: 'profile.signout',
      onClick: () => signOut(),
    },
  ];

  return (
    <div
      ref={authRef}
      className={`dropdown px-0 px-md-2 d-flex flex-column justify-content-center align-items-end col header-auth-container`}
    >
      <button
        name="userInfoMenu"
        id="userInfoMenu"
        className="btn border-0 p-1 d-flex text-primary-dark dropdown-toggle align-items-baseline cursor-pointer font-msmall btn-userInfo"
        onClick={() => setIsShow(!isShow)}
        data-toggle="collapse"
        data-target="#userInfoCollapse"
        aria-expanded="true"
        aria-controls="userInfoCollapse"
      >
        <FormattedMessage id="profile.hi" />
        {','}
        <span className="text-truncate">
          {' '}
          {fullName.length >= 5 ? `${fullName.substring(0, 5)}...` : fullName}
        </span>
      </button>
      {isShow && (
        <ul
          id="userInfoCollapse"
          className={`show  font-small font-sm-msmall p-0 m-0 list-unstyled position-absolute bg-white border border-third-light default-border-radius-xsmall menu-userInfo shadow auth-list-container`}
          aria-labelledby="userInfoMenu"
        >
          {AUTHENTICATION_LIST.map((item, index) => (
            <li
              key={item.id}
              className={`w-100 d-flex font-small py-2 dropdown-item cursor-pointer ${
                index === 0 ? 'default-border-top-radius-xsmall' : ''
              } ${
                index === AUTHENTICATION_LIST
                  ? 'default-border-bottom-radius-xsmall'
                  : 'border-bottom'
              }`}
              onClick={() => {
                item.onClick();
                setIsShow(false);
              }}
            >
              <FormattedMessage id={item.label} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

HeaderAuth.propTypes = {
  signOut: PropTypes.func,
  fullName: PropTypes.string,
};

export default HeaderAuth;
